(function tlFGClone() {
    function patch(offer) {
        const _original = offer.detectCartData.bind(offer);

        offer.detectCartData = (async function () {
            await _original();
            
            const onlyGiftsInCart =
                this.itemsInCart.size === 0 &&
                Array.from(this.ruleIdMapGifts.values()).some(g => g.length > 0);

            if (onlyGiftsInCart) {
                await fetch(
                    window.Shopify.routes.root + 'cart/clear.js?app=salepify',
                    { method: 'POST', headers: { 'Content-Type': 'application/json' } }
                );
                await _original();
                await this.refreshCartContent();
            }
        }).bind(offer);
    }

    function init() {
        if (window.tlFreeGiftOffer) return patch(window.tlFreeGiftOffer);
        const timer = setInterval(() => {
            if (window.tlFreeGiftOffer) {
                clearInterval(timer);
                patch(window.tlFreeGiftOffer);
            }
        }, 100);
    }

    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', init)
        : init();
})();
